module.exports = __webpack_public_path__ + "img/salmon.20c2c25b.png";